import supabase from "./supabase";

export async function getUserByEmail(
  email: string
): Promise<{ user: any; error: string | null }> {
  try {
    const { data, error } = await supabase.functions.invoke("getStudentEmail", {
      body: { email },
    });

    if (error) {
      return { user: null, error: error.message };
    }

    return { user: data.user, error: null };
  } catch (error: any) {
    console.error("Error getting user by email:", error);
    return {
      user: null,
      error: error.message || "Failed to get user by email",
    };
  }
}
